import { ApiProperty } from "@nestjs/swagger";

export class RmZoneRackLevelByIdDto{
    @ApiProperty()
    rackId:number;
    zoneId:number;
    levelId:number;
}